import { PageLevelTypes } from "@enums/page-level-types";
import { getThemingPropertyValueOrigin } from "@utils/dcui-data-util";
import { cloneElement, ReactElement, useMemo } from "react";
import styles from "./theming-form-group-wrapper.less";

type ThemingFormGroupWrapperProps = {
    children: ReactElement;
    inheritedThemingPropertyValue: string | boolean;
    currentThemingPropertyValue: string | boolean;
    pageLevel: PageLevelTypes;
    hideComparison?: boolean;
};

export const ThemingFormGroupWrapper = (props: ThemingFormGroupWrapperProps) => {
    const {
        children,
        inheritedThemingPropertyValue,
        currentThemingPropertyValue,
        pageLevel,
        hideComparison
    } = props;


    const rightAlignedLabelElement = useMemo(() => {
        return !hideComparison ? (
            <div className={styles.rightAlignedElement}>
                {getThemingPropertyValueOrigin(inheritedThemingPropertyValue, currentThemingPropertyValue, pageLevel)}
            </div>
        ) : null;
    }, [pageLevel, inheritedThemingPropertyValue, currentThemingPropertyValue]);
    //@ts-ignore
    return cloneElement(children, { rightAlignedLabelElement });
};